// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Vendor_pageHeader__htQtj {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid var(--border);
  margin-bottom: 16px;
}
.Vendor_pageHeader__htQtj h1 {
  font: var(--h3);
  font-weight: 700;
  color: var(--primary-Text);
  font-family: var(--font-bodoni-72);
}
.Vendor_pageHeader__htQtj .Vendor_right__zPqHO {
  display: flex;
  align-items: center;
  gap: 20px;
}
.Vendor_pageHeader__htQtj .Vendor_right__zPqHO .Vendor_date__CyqCM {
  display: flex;
  align-items: center;
  gap: 4px;
}
.Vendor_pageHeader__htQtj .Vendor_right__zPqHO .Vendor_date__CyqCM img,
.Vendor_pageHeader__htQtj .Vendor_right__zPqHO .Vendor_date__CyqCM svg {
  width: 16px;
  height: 16px;
  object-fit: scale-down;
  display: block;
}
.Vendor_pageHeader__htQtj .Vendor_right__zPqHO .Vendor_date__CyqCM span {
  font: var(--body-font-four);
  color: var(--primary-Text);
  display: block;
}

.Vendor_pageMain__rOqeH {
  padding: 0 24px;
}
.Vendor_pageMain__rOqeH .Vendor_pageScreen__WpS6V {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  padding: 16px 0;
}
@media screen and (max-width: 1420px) {
  .Vendor_pageMain__rOqeH .Vendor_pageScreen__WpS6V.Vendor_sidebarExpand__BR2j1 {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media screen and (max-width: 1040px) {
  .Vendor_pageMain__rOqeH .Vendor_pageScreen__WpS6V.Vendor_sidebarExpand__BR2j1 {
    grid-template-columns: repeat(1, 1fr);
  }
}
@media screen and (max-width: 768px) {
  .Vendor_pageMain__rOqeH .Vendor_pageScreen__WpS6V.Vendor_sidebarExpand__BR2j1 {
    grid-template-columns: repeat(1, 1fr);
  }
}
@media screen and (max-width: 1200px) {
  .Vendor_pageMain__rOqeH .Vendor_pageScreen__WpS6V {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media screen and (max-width: 870px) {
  .Vendor_pageMain__rOqeH .Vendor_pageScreen__WpS6V {
    grid-template-columns: repeat(1, 1fr);
  }
}

.Vendor_mainTabs__aQRgc .Vendor_detailsWrp__ykhZg {
  margin-top: 16px;
}
.Vendor_mainTabs__aQRgc .Vendor_topRow__Odqo9 {
  width: 100%;
  padding-bottom: 12px;
}
.Vendor_mainTabs__aQRgc .Vendor_topRow__Odqo9 .Vendor_filterBtns__Ar3Dg {
  display: flex;
  gap: 12px;
  align-items: center;
  flex: 1 1;
  justify-content: flex-end;
}
.Vendor_mainTabs__aQRgc .Vendor_topRow__Odqo9 .Vendor_filterBtns__Ar3Dg .Vendor_rightActions__7G1Js {
  display: flex;
  align-items: center;
  gap: 12px;
}
.Vendor_mainTabs__aQRgc .Vendor_topRow__Odqo9 .Vendor_filterBtns__Ar3Dg .Vendor_left__8vUkM .Vendor_tabItem__hicRV {
  display: flex;
  align-items: center;
  gap: 8px;
  text-align: left;
}
.Vendor_mainTabs__aQRgc .Vendor_topRow__Odqo9 .Vendor_filterBtns__Ar3Dg .Vendor_left__8vUkM .Vendor_tabItem__hicRV.Vendor_selected__nCWDV img,
.Vendor_mainTabs__aQRgc .Vendor_topRow__Odqo9 .Vendor_filterBtns__Ar3Dg .Vendor_left__8vUkM .Vendor_tabItem__hicRV.Vendor_selected__nCWDV svg {
  filter: grayscale(0);
}
.Vendor_mainTabs__aQRgc .Vendor_topRow__Odqo9 .Vendor_filterBtns__Ar3Dg .Vendor_left__8vUkM .Vendor_tabItem__hicRV.Vendor_selected__nCWDV span {
  color: var(--brand);
}
.Vendor_mainTabs__aQRgc .Vendor_topRow__Odqo9 .Vendor_filterBtns__Ar3Dg .Vendor_left__8vUkM .Vendor_tabItem__hicRV span {
  color: var(--secondary-Text);
  font: var(--body-font-three);
  font-weight: 500;
}
.Vendor_mainTabs__aQRgc .Vendor_topRow__Odqo9 .Vendor_filterBtns__Ar3Dg .Vendor_left__8vUkM .Vendor_tabItem__hicRV img,
.Vendor_mainTabs__aQRgc .Vendor_topRow__Odqo9 .Vendor_filterBtns__Ar3Dg .Vendor_left__8vUkM .Vendor_tabItem__hicRV svg {
  width: 16px;
  height: 16px;
  display: block;
  filter: grayscale(1);
}

@media (max-width: 599px) {
  .Vendor_mainTabs__aQRgc .Vendor_topRow__Odqo9 .Vendor_filterBtns__Ar3Dg .Vendor_rightActions__7G1Js {
    width: 100%;
  }
  .Vendor_mainTabs__aQRgc .Vendor_topRow__Odqo9 .Vendor_filterBtns__Ar3Dg .Vendor_rightActions__7G1Js button {
    width: 100%;
  }
}
.Vendor_cardView__WMCWi {
  background-color: var(--white);
  border-radius: 12px;
  border: 1px solid var(--border);
  overflow: hidden;
}
.Vendor_cardView__WMCWi .Vendor_cardHead__B9tcp {
  background-color: var(--bg1);
  padding: 12px 0 12px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.Vendor_cardView__WMCWi .Vendor_cardHead__B9tcp .Vendor_cardHeadLeft__UdRgq {
  display: flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
  max-width: calc(100% - 150px);
  overflow: hidden;
}
@media screen and (max-width: 450px) {
  .Vendor_cardView__WMCWi .Vendor_cardHead__B9tcp .Vendor_cardHeadLeft__UdRgq {
    flex-direction: column;
    align-items: start;
    width: 100%;
    max-width: 100%;
  }
}
.Vendor_cardView__WMCWi .Vendor_cardHead__B9tcp .Vendor_cardHeadLeft__UdRgq figure {
  display: flex;
}
.Vendor_cardView__WMCWi .Vendor_cardHead__B9tcp .Vendor_cardHeadLeft__UdRgq figure img {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 50%;
  object-position: center;
  overflow: hidden;
  border: 1px solid var(--border);
}
.Vendor_cardView__WMCWi .Vendor_cardHead__B9tcp .Vendor_cardResponse__ptWak {
  width: fit-content;
}
@media screen and (max-width: 450px) {
  .Vendor_cardView__WMCWi .Vendor_cardHead__B9tcp .Vendor_cardResponse__ptWak {
    position: absolute;
    right: 0;
    top: 16px;
  }
}
.Vendor_cardView__WMCWi .Vendor_cardHead__B9tcp .Vendor_cardHeadText__bokVl {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: 100%;
}
@media screen and (max-width: 450px) {
  .Vendor_cardView__WMCWi .Vendor_cardHead__B9tcp .Vendor_cardHeadText__bokVl {
    max-width: calc(100% - 12px);
  }
}
.Vendor_cardView__WMCWi .Vendor_cardHead__B9tcp .Vendor_cardHeadText__bokVl h2 {
  font: var(--body-font-two);
  font-weight: 600;
  color: var(--primary-Text);
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
  white-space: nowrap;
}
.Vendor_cardView__WMCWi .Vendor_cardHead__B9tcp .Vendor_cardHeadText__bokVl .Vendor_cardHeadTextSub__TUMF0 {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}
.Vendor_cardView__WMCWi .Vendor_cardHead__B9tcp .Vendor_cardHeadText__bokVl .Vendor_cardHeadTextSub__TUMF0 p {
  font: var(--body-font-four);
  font-weight: 400;
  color: var(--secondary-Text);
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  padding-left: 8px;
  border-left: 1px solid var(--border);
}
.Vendor_cardView__WMCWi .Vendor_cardHead__B9tcp .Vendor_cardHeadText__bokVl .Vendor_cardHeadTextSub__TUMF0 p:first-child {
  padding-left: 0;
  border-left: 0;
}
.Vendor_cardView__WMCWi .Vendor_cardHead__B9tcp .Vendor_cardHeadText__bokVl .Vendor_cardHeadTextSub__TUMF0 p img {
  width: 16px;
  height: 16px;
}
.Vendor_cardView__WMCWi .Vendor_cardBodyMain__BpDKj {
  background-color: var(--white);
  border-top: 1px solid var(--border);
  padding: 12px;
}
.Vendor_cardView__WMCWi .Vendor_cardBodyMain__BpDKj.Vendor_noDescription__yT8Y1 {
  border-top: none;
}
.Vendor_cardView__WMCWi .Vendor_cardBodyMain__BpDKj .Vendor_cardBody__KFO0C p {
  font: var(--body-font-three);
  font-weight: 500;
  color: var(--brand);
}
.Vendor_cardView__WMCWi .Vendor_cardBodyMain__BpDKj .Vendor_cardBody__KFO0C span {
  font: var(--body-font-three);
  font-weight: 400;
  color: var(--secondary-Text);
  display: block;
  margin-top: 4px;
}
.Vendor_cardView__WMCWi .Vendor_cardBodyMain__BpDKj .Vendor_cardFooter__gIZbA {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid var(--border);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media screen and (max-width: 450px) {
  .Vendor_cardView__WMCWi .Vendor_cardBodyMain__BpDKj .Vendor_cardFooter__gIZbA {
    flex-direction: column;
    gap: 16px;
    align-items: start;
  }
}
.Vendor_cardView__WMCWi .Vendor_cardBodyMain__BpDKj .Vendor_cardFooter__gIZbA p {
  font: var(--body-font-three);
  font-weight: 600;
  color: var(--primary-Text);
}
.Vendor_cardView__WMCWi .Vendor_cardBodyMain__BpDKj .Vendor_cardFooter__gIZbA .Vendor_cardFooterBtn__lhPR5 {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
}
.Vendor_cardView__WMCWi .Vendor_cardBodyMain__BpDKj .Vendor_cardFooter__gIZbA .Vendor_cardFooterBtn__lhPR5 img {
  filter: brightness(0) invert(1);
}
@media screen and (max-width: 450px) {
  .Vendor_cardView__WMCWi .Vendor_cardBodyMain__BpDKj .Vendor_cardFooter__gIZbA .Vendor_cardFooterBtn__lhPR5 {
    width: 100%;
  }
  .Vendor_cardView__WMCWi .Vendor_cardBodyMain__BpDKj .Vendor_cardFooter__gIZbA .Vendor_cardFooterBtn__lhPR5 button {
    width: 100%;
  }
}
.Vendor_cardView__WMCWi .Vendor_cardBodyMain__BpDKj.Vendor_noDescription__yT8Y1 .Vendor_cardFooter__gIZbA {
  border-top: none;
  padding-top: 0;
  margin-top: 0;
}
.Vendor_cardView__WMCWi .Vendor_cardStatus__89xRw {
  padding: 8px;
  border-radius: 8px;
  background-color: var(--bg3);
}
.Vendor_cardView__WMCWi .Vendor_cardStatus__89xRw.Vendor_submitted__Xqxzk, .Vendor_cardView__WMCWi .Vendor_cardStatus__89xRw.Vendor_pending__lOjbw {
  background-color: var(--bg3);
}
.Vendor_cardView__WMCWi .Vendor_cardStatus__89xRw.Vendor_submitted__Xqxzk p, .Vendor_cardView__WMCWi .Vendor_cardStatus__89xRw.Vendor_pending__lOjbw p {
  color: var(--brand);
}
.Vendor_cardView__WMCWi .Vendor_cardStatus__89xRw.Vendor_submitted__Xqxzk p:before, .Vendor_cardView__WMCWi .Vendor_cardStatus__89xRw.Vendor_pending__lOjbw p:before {
  background-color: var(--brand);
}
.Vendor_cardView__WMCWi .Vendor_cardStatus__89xRw.Vendor_in-review__qBQN3, .Vendor_cardView__WMCWi .Vendor_cardStatus__89xRw.Vendor_in-progress__MzcHO {
  background-color: #fff5e9;
}
.Vendor_cardView__WMCWi .Vendor_cardStatus__89xRw.Vendor_in-review__qBQN3 p, .Vendor_cardView__WMCWi .Vendor_cardStatus__89xRw.Vendor_in-progress__MzcHO p {
  color: var(--warning);
}
.Vendor_cardView__WMCWi .Vendor_cardStatus__89xRw.Vendor_in-review__qBQN3 p:before, .Vendor_cardView__WMCWi .Vendor_cardStatus__89xRw.Vendor_in-progress__MzcHO p:before {
  background-color: var(--warning);
}
.Vendor_cardView__WMCWi .Vendor_cardStatus__89xRw.Vendor_approved__R0erJ, .Vendor_cardView__WMCWi .Vendor_cardStatus__89xRw.Vendor_completed__Kj1BA {
  background-color: #edf7ee;
}
.Vendor_cardView__WMCWi .Vendor_cardStatus__89xRw.Vendor_approved__R0erJ p, .Vendor_cardView__WMCWi .Vendor_cardStatus__89xRw.Vendor_completed__Kj1BA p {
  color: var(--success);
}
.Vendor_cardView__WMCWi .Vendor_cardStatus__89xRw.Vendor_approved__R0erJ p:before, .Vendor_cardView__WMCWi .Vendor_cardStatus__89xRw.Vendor_completed__Kj1BA p:before {
  background-color: var(--success);
}
.Vendor_cardView__WMCWi .Vendor_cardStatus__89xRw.Vendor_declined__Y\\+m6A {
  background-color: #feeceb;
}
.Vendor_cardView__WMCWi .Vendor_cardStatus__89xRw.Vendor_declined__Y\\+m6A p {
  color: var(--error);
}
.Vendor_cardView__WMCWi .Vendor_cardStatus__89xRw.Vendor_declined__Y\\+m6A p:before {
  background-color: var(--error);
}
.Vendor_cardView__WMCWi .Vendor_cardStatus__89xRw p {
  font: var(--body-font-four);
  font-weight: 500;
  color: var(--brand);
  position: relative;
  padding-left: 8px;
  text-align: center;
  width: fit-content;
  margin: 0 auto;
  text-transform: capitalize;
}
.Vendor_cardView__WMCWi .Vendor_cardStatus__89xRw p:before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: var(--brand);
}`, "",{"version":3,"sources":["webpack://./src/components/UserDashboard/Vendor/index.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,sCAAA;EACA,mBAAA;AACD;AACC;EACC,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kCAAA;AACF;AAEC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AAAF;AAEE;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AAAH;AAEG;;EAEC,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AAAJ;AAGG;EACC,2BAAA;EACA,0BAAA;EACA,cAAA;AADJ;;AAOA;EACC,eAAA;AAJD;AAMC;EACC,aAAA;EACA,qCAAA;EACA,SAAA;EACA,eAAA;AAJF;AAOG;EADD;IAEE,qCAAA;EAJF;AACF;AAMG;EALD;IAME,qCAAA;EAHF;AACF;AAKG;EATD;IAUE,qCAAA;EAFF;AACF;AAKE;EApBD;IAqBE,qCAAA;EAFD;AACF;AAIE;EAxBD;IAyBE,qCAAA;EADD;AACF;;AAMC;EACC,gBAAA;AAHF;AAMC;EACC,WAAA;EACA,oBAAA;AAJF;AAME;EACC,aAAA;EAEA,SAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;AALH;AAOG;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AALJ;AASI;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAPL;AAUM;;EAEC,oBAAA;AARP;AAWM;EACC,mBAAA;AATP;AAaK;EACC,4BAAA;EACA,4BAAA;EACA,gBAAA;AAXN;AAcK;;EAEC,WAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;AAZN;;AAoBA;EAMI;IACC,WAAA;EAtBH;EAwBG;IACC,WAAA;EAtBJ;AACF;AA6BA;EACC,8BAAA;EACA,mBAAA;EACA,+BAAA;EACA,gBAAA;AA3BD;AA6BC;EACC,4BAAA;EACA,yBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AA3BF;AAkCE;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,6BAAA;EACA,gBAAA;AAhCH;AAkCG;EARD;IASE,sBAAA;IACA,kBAAA;IACA,WAAA;IACA,eAAA;EA/BF;AACF;AAiCG;EACC,aAAA;AA/BJ;AAiCI;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,+BAAA;AA/BL;AAoCE;EACC,kBAAA;AAlCH;AAoCG;EAHD;IAKE,kBAAA;IACA,QAAA;IACA,SAAA;EAlCF;AACF;AAqCE;EACC,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;AAnCH;AAqCG;EAND;IAOE,4BAAA;EAlCF;AACF;AAoCG;EACC,0BAAA;EACA,gBAAA;EACA,0BAAA;EAEA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAnCJ;AAsCG;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AApCJ;AAsCI;EACC,2BAAA;EACA,gBAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EAEA,iBAAA;EACA,oCAAA;AArCL;AAuCK;EACC,eAAA;EACA,cAAA;AArCN;AAwCK;EACC,WAAA;EACA,YAAA;AAtCN;AA6CC;EACC,8BAAA;EACA,mCAAA;EACA,aAAA;AA3CF;AA6CE;EACC,gBAAA;AA3CH;AA+CG;EACC,4BAAA;EACA,gBAAA;EACA,mBAAA;AA7CJ;AAgDG;EACC,4BAAA;EACA,gBAAA;EACA,4BAAA;EACA,cAAA;EACA,eAAA;AA9CJ;AAkDE;EACC,gBAAA;EACA,iBAAA;EACA,mCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAhDH;AAkDG;EARD;IASE,sBAAA;IACA,SAAA;IACA,kBAAA;EA/CF;AACF;AAiDG;EACC,4BAAA;EACA,gBAAA;EACA,0BAAA;AA/CJ;AAkDG;EACC,aAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;AAhDJ;AAkDI;EACC,+BAAA;AAhDL;AAmDI;EAVD;IAWE,WAAA;EAhDH;EAkDG;IACC,WAAA;EAhDJ;AACF;AAoDE;EACC,gBAAA;EACA,cAAA;EACA,aAAA;AAlDH;AAsDC;EACC,YAAA;EACA,kBAAA;EACA,4BAAA;AApDF;AAsDE;EAEC,4BAAA;AArDH;AAuDG;EACC,mBAAA;AArDJ;AAuDI;EACC,8BAAA;AArDL;AA0DE;EAEC,yBAAA;AAzDH;AA2DG;EACC,qBAAA;AAzDJ;AA2DI;EACC,gCAAA;AAzDL;AA8DE;EAEC,yBAAA;AA7DH;AA+DG;EACC,qBAAA;AA7DJ;AA+DI;EACC,gCAAA;AA7DL;AAkEE;EACC,yBAAA;AAhEH;AAkEG;EACC,mBAAA;AAhEJ;AAkEI;EACC,8BAAA;AAhEL;AAqEE;EACC,2BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,0BAAA;AAnEH;AAqEG;EACC,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,8BAAA;AAnEJ","sourcesContent":[".pageHeader {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tpadding: 16px 24px;\r\n\tborder-bottom: 1px solid var(--border);\r\n\tmargin-bottom: 16px;\r\n\r\n\th1 {\r\n\t\tfont: var(--h3);\r\n\t\tfont-weight: 700;\r\n\t\tcolor: var(--primary-Text);\r\n\t\tfont-family: var(--font-bodoni-72);\r\n\t}\r\n\r\n\t.right {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tgap: 20px;\r\n\r\n\t\t.date {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 4px;\r\n\r\n\t\t\timg,\r\n\t\t\tsvg {\r\n\t\t\t\twidth: 16px;\r\n\t\t\t\theight: 16px;\r\n\t\t\t\tobject-fit: scale-down;\r\n\t\t\t\tdisplay: block;\r\n\t\t\t}\r\n\r\n\t\t\tspan {\r\n\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\tdisplay: block;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.pageMain {\r\n\tpadding: 0 24px;\r\n\r\n\t.pageScreen {\r\n\t\tdisplay: grid;\r\n\t\tgrid-template-columns: repeat(3, 1fr);\r\n\t\tgap: 20px;\r\n\t\tpadding: 16px 0;\r\n\r\n\t\t&.sidebarExpand {\r\n\t\t\t@media screen and (max-width: 1420px) {\r\n\t\t\t\tgrid-template-columns: repeat(2, 1fr);\r\n\t\t\t}\r\n\r\n\t\t\t@media screen and (max-width: 1040px) {\r\n\t\t\t\tgrid-template-columns: repeat(1, 1fr);\r\n\t\t\t}\r\n\r\n\t\t\t@media screen and (max-width: 768px) {\r\n\t\t\t\tgrid-template-columns: repeat(1, 1fr);\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t@media screen and (max-width: 1200px) {\r\n\t\t\tgrid-template-columns: repeat(2, 1fr);\r\n\t\t}\r\n\r\n\t\t@media screen and (max-width: 870px) {\r\n\t\t\tgrid-template-columns: repeat(1, 1fr);\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.mainTabs {\r\n\t.detailsWrp {\r\n\t\tmargin-top: 16px;\r\n\t}\r\n\r\n\t.topRow {\r\n\t\twidth: 100%;\r\n\t\tpadding-bottom: 12px;\r\n\r\n\t\t.filterBtns {\r\n\t\t\tdisplay: flex;\r\n\t\t\t// flex-wrap: wrap;\r\n\t\t\tgap: 12px;\r\n\t\t\talign-items: center;\r\n\t\t\tflex: 1;\r\n\t\t\tjustify-content: flex-end;\r\n\r\n\t\t\t.rightActions {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 12px;\r\n\t\t\t}\r\n\r\n\t\t\t.left {\r\n\t\t\t\t.tabItem {\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\talign-items: center;\r\n\t\t\t\t\tgap: 8px;\r\n\t\t\t\t\ttext-align: left;\r\n\r\n\t\t\t\t\t&.selected {\r\n\t\t\t\t\t\timg,\r\n\t\t\t\t\t\tsvg {\r\n\t\t\t\t\t\t\tfilter: grayscale(0);\r\n\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\tspan {\r\n\t\t\t\t\t\t\tcolor: var(--brand);\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\tspan {\r\n\t\t\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\t\t\tfont-weight: 500;\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\timg,\r\n\t\t\t\t\tsvg {\r\n\t\t\t\t\t\twidth: 16px;\r\n\t\t\t\t\t\theight: 16px;\r\n\t\t\t\t\t\tdisplay: block;\r\n\t\t\t\t\t\tfilter: grayscale(1);\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 599px) {\r\n\t.mainTabs {\r\n\t\t.topRow {\r\n\t\t\t.filterBtns {\r\n\t\t\t\t// flex-direction: column;\r\n\t\t\t\t// align-items: flex-start;\r\n\t\t\t\t.rightActions {\r\n\t\t\t\t\twidth: 100%;\r\n\r\n\t\t\t\t\tbutton {\r\n\t\t\t\t\t\twidth: 100%;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.cardView {\r\n\tbackground-color: var(--white);\r\n\tborder-radius: 12px;\r\n\tborder: 1px solid var(--border);\r\n\toverflow: hidden;\r\n\r\n\t.cardHead {\r\n\t\tbackground-color: var(--bg1);\r\n\t\tpadding: 12px 0 12px 12px;\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tposition: relative;\r\n\r\n\t\t@media screen and (max-width: 450px) {\r\n\t\t\t// flex-direction: column;\r\n\t\t\t// gap: 16px;\r\n\t\t}\r\n\r\n\t\t.cardHeadLeft {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 8px;\r\n\t\t\twidth: fit-content;\r\n\t\t\tmax-width: calc(100% - 150px);\r\n\t\t\toverflow: hidden;\r\n\r\n\t\t\t@media screen and (max-width: 450px) {\r\n\t\t\t\tflex-direction: column;\r\n\t\t\t\talign-items: start;\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\tmax-width: 100%;\r\n\t\t\t}\r\n\r\n\t\t\tfigure {\r\n\t\t\t\tdisplay: flex;\r\n\r\n\t\t\t\timg {\r\n\t\t\t\t\twidth: 48px;\r\n\t\t\t\t\theight: 48px;\r\n\t\t\t\t\tobject-fit: cover;\r\n\t\t\t\t\tborder-radius: 50%;\r\n\t\t\t\t\tobject-position: center;\r\n\t\t\t\t\toverflow: hidden;\r\n\t\t\t\t\tborder: 1px solid var(--border);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.cardResponse {\r\n\t\t\twidth: fit-content;\r\n\r\n\t\t\t@media screen and (max-width: 450px) {\r\n\t\t\t\t// width: 100%;\r\n\t\t\t\tposition: absolute;\r\n\t\t\t\tright: 0;\r\n\t\t\t\ttop: 16px;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.cardHeadText {\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-direction: column;\r\n\t\t\tgap: 4px;\r\n\t\t\tmax-width: 100%;\r\n\r\n\t\t\t@media screen and (max-width: 450px) {\r\n\t\t\t\tmax-width: calc(100% - 12px);\r\n\t\t\t}\r\n\r\n\t\t\th2 {\r\n\t\t\t\tfont: var(--body-font-two);\r\n\t\t\t\tfont-weight: 600;\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\r\n\t\t\t\ttext-overflow: ellipsis;\r\n\t\t\t\toverflow: hidden;\r\n\t\t\t\tmax-width: 100%;\r\n\t\t\t\twhite-space: nowrap;\r\n\t\t\t}\r\n\r\n\t\t\t.cardHeadTextSub {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tjustify-content: start;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 8px;\r\n\t\t\t\tmargin-top: 4px;\r\n\r\n\t\t\t\tp {\r\n\t\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\t\tfont-weight: 400;\r\n\t\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\talign-items: center;\r\n\t\t\t\t\tgap: 4px;\r\n\t\t\t\t\tmargin: 0;\r\n\r\n\t\t\t\t\tpadding-left: 8px;\r\n\t\t\t\t\tborder-left: 1px solid var(--border);\r\n\r\n\t\t\t\t\t&:first-child {\r\n\t\t\t\t\t\tpadding-left: 0;\r\n\t\t\t\t\t\tborder-left: 0;\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\timg {\r\n\t\t\t\t\t\twidth: 16px;\r\n\t\t\t\t\t\theight: 16px;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.cardBodyMain {\r\n\t\tbackground-color: var(--white);\r\n\t\tborder-top: 1px solid var(--border);\r\n\t\tpadding: 12px;\r\n\r\n\t\t&.noDescription {\r\n\t\t\tborder-top: none;\r\n\t\t}\r\n\r\n\t\t.cardBody {\r\n\t\t\tp {\r\n\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\tfont-weight: 500;\r\n\t\t\t\tcolor: var(--brand);\r\n\t\t\t}\r\n\r\n\t\t\tspan {\r\n\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\tfont-weight: 400;\r\n\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\tdisplay: block;\r\n\t\t\t\tmargin-top: 4px;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.cardFooter {\r\n\t\t\tmargin-top: 16px;\r\n\t\t\tpadding-top: 16px;\r\n\t\t\tborder-top: 1px solid var(--border);\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: space-between;\r\n\t\t\talign-items: center;\r\n\r\n\t\t\t@media screen and (max-width: 450px) {\r\n\t\t\t\tflex-direction: column;\r\n\t\t\t\tgap: 16px;\r\n\t\t\t\talign-items: start;\r\n\t\t\t}\r\n\r\n\t\t\tp {\r\n\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\tfont-weight: 600;\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t}\r\n\r\n\t\t\t.cardFooterBtn {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tgap: 12px;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tjustify-content: space-between;\r\n\r\n\t\t\t\timg {\r\n\t\t\t\t\tfilter: brightness(0) invert(1);\r\n\t\t\t\t}\r\n\r\n\t\t\t\t@media screen and (max-width: 450px) {\r\n\t\t\t\t\twidth: 100%;\r\n\r\n\t\t\t\t\tbutton {\r\n\t\t\t\t\t\twidth: 100%;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t\t&.noDescription .cardFooter{\r\n\t\t\tborder-top: none;\r\n\t\t\tpadding-top: 0;\r\n\t\t\tmargin-top: 0;\r\n\t\t}\r\n\t}\r\n\r\n\t.cardStatus {\r\n\t\tpadding: 8px;\r\n\t\tborder-radius: 8px;\r\n\t\tbackground-color: var(--bg3);\r\n\r\n\t\t&.submitted,\r\n\t\t&.pending {\r\n\t\t\tbackground-color: var(--bg3);\r\n\r\n\t\t\tp {\r\n\t\t\t\tcolor: var(--brand);\r\n\r\n\t\t\t\t&:before {\r\n\t\t\t\t\tbackground-color: var(--brand);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t&.in-review,\r\n\t\t&.in-progress {\r\n\t\t\tbackground-color: #fff5e9;\r\n\r\n\t\t\tp {\r\n\t\t\t\tcolor: var(--warning);\r\n\r\n\t\t\t\t&:before {\r\n\t\t\t\t\tbackground-color: var(--warning);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t&.approved,\r\n\t\t&.completed {\r\n\t\t\tbackground-color: #edf7ee;\r\n\r\n\t\t\tp {\r\n\t\t\t\tcolor: var(--success);\r\n\r\n\t\t\t\t&:before {\r\n\t\t\t\t\tbackground-color: var(--success);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t&.declined {\r\n\t\t\tbackground-color: #feeceb;\r\n\r\n\t\t\tp {\r\n\t\t\t\tcolor: var(--error);\r\n\r\n\t\t\t\t&:before {\r\n\t\t\t\t\tbackground-color: var(--error);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\tp {\r\n\t\t\tfont: var(--body-font-four);\r\n\t\t\tfont-weight: 500;\r\n\t\t\tcolor: var(--brand);\r\n\t\t\tposition: relative;\r\n\t\t\tpadding-left: 8px;\r\n\t\t\ttext-align: center;\r\n\t\t\twidth: fit-content;\r\n\t\t\tmargin: 0 auto;\r\n\t\t\ttext-transform: capitalize;\r\n\r\n\t\t\t&:before {\r\n\t\t\t\tcontent: '';\r\n\t\t\t\tposition: absolute;\r\n\t\t\t\ttop: 50%;\r\n\t\t\t\tleft: 0;\r\n\t\t\t\ttransform: translateY(-50%);\r\n\t\t\t\twidth: 4px;\r\n\t\t\t\theight: 4px;\r\n\t\t\t\tborder-radius: 50%;\r\n\t\t\t\tbackground-color: var(--brand);\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageHeader": `Vendor_pageHeader__htQtj`,
	"right": `Vendor_right__zPqHO`,
	"date": `Vendor_date__CyqCM`,
	"pageMain": `Vendor_pageMain__rOqeH`,
	"pageScreen": `Vendor_pageScreen__WpS6V`,
	"sidebarExpand": `Vendor_sidebarExpand__BR2j1`,
	"mainTabs": `Vendor_mainTabs__aQRgc`,
	"detailsWrp": `Vendor_detailsWrp__ykhZg`,
	"topRow": `Vendor_topRow__Odqo9`,
	"filterBtns": `Vendor_filterBtns__Ar3Dg`,
	"rightActions": `Vendor_rightActions__7G1Js`,
	"left": `Vendor_left__8vUkM`,
	"tabItem": `Vendor_tabItem__hicRV`,
	"selected": `Vendor_selected__nCWDV`,
	"cardView": `Vendor_cardView__WMCWi`,
	"cardHead": `Vendor_cardHead__B9tcp`,
	"cardHeadLeft": `Vendor_cardHeadLeft__UdRgq`,
	"cardResponse": `Vendor_cardResponse__ptWak`,
	"cardHeadText": `Vendor_cardHeadText__bokVl`,
	"cardHeadTextSub": `Vendor_cardHeadTextSub__TUMF0`,
	"cardBodyMain": `Vendor_cardBodyMain__BpDKj`,
	"noDescription": `Vendor_noDescription__yT8Y1`,
	"cardBody": `Vendor_cardBody__KFO0C`,
	"cardFooter": `Vendor_cardFooter__gIZbA`,
	"cardFooterBtn": `Vendor_cardFooterBtn__lhPR5`,
	"cardStatus": `Vendor_cardStatus__89xRw`,
	"submitted": `Vendor_submitted__Xqxzk`,
	"pending": `Vendor_pending__lOjbw`,
	"in-review": `Vendor_in-review__qBQN3`,
	"in-progress": `Vendor_in-progress__MzcHO`,
	"approved": `Vendor_approved__R0erJ`,
	"completed": `Vendor_completed__Kj1BA`,
	"declined": `Vendor_declined__Y+m6A`
};
export default ___CSS_LOADER_EXPORT___;
